export default __webpack_public_path__ + "static/media/504.7448279e.gif";